module.exports = __webpack_public_path__ + "img/logoG.078f6981.jpeg";